module.exports = __webpack_public_path__ + "img/cww_03.1191a6e9.jpg";